import { Card, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Email, EmailCompose } from "../../../Constant";
import { MailSideBar } from "../Common/MailSideBar";
import EmailComposeContainerData from "./EmailComposeContainData";
import ComposeMessage from "./ComposeMessage";

const EmailComposeContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={EmailCompose} parent={Email} title={EmailCompose} />
      <Container fluid>
        <div className="email-wrap">
          <Row>
            <MailSideBar />
            <Col xl="9" className="box-col-8">
              <div className="email-right-aside">
                <Card className="email-body">
                  <Row>
                    <EmailComposeContainerData />
                    <ComposeMessage />
                  </Row>
                </Card>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default EmailComposeContainer;
